export default __webpack_public_path__ + "static/media/logo-card-1024w.c2786dfc.png";